/* @generated from adl module ferovinum.app.tradesale */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as ferovinum_app_db from './db';

export interface TradeSaleAction_Cancelled {
  kind: 'cancelled';
}
export interface TradeSaleAction_Purchaser_accepted {
  kind: 'purchaser_accepted';
  value: (CollectionDetails|null);
}
export interface TradeSaleAction_Purchaser_rejected {
  kind: 'purchaser_rejected';
}
export interface TradeSaleAction_Production_order_complete {
  kind: 'production_order_complete';
}
export interface TradeSaleAction_Ready_for_collection {
  kind: 'ready_for_collection';
}
export interface TradeSaleAction_Collected {
  kind: 'collected';
  value: common.LocalDate;
}
export interface TradeSaleAction_Delivered {
  kind: 'delivered';
  value: common.LocalDate;
}
export interface TradeSaleAction_Purchaser_invoiced {
  kind: 'purchaser_invoiced';
  value: common_db.DbKey<ferovinum_app_db.Invoice>;
}
export interface TradeSaleAction_Purchaser_paid {
  kind: 'purchaser_paid';
  value: common.LocalDate;
}
export interface TradeSaleAction_Paid_organisation {
  kind: 'paid_organisation';
  value: OrgPaymentInfo;
}

export type TradeSaleAction = TradeSaleAction_Cancelled | TradeSaleAction_Purchaser_accepted | TradeSaleAction_Purchaser_rejected | TradeSaleAction_Production_order_complete | TradeSaleAction_Ready_for_collection | TradeSaleAction_Collected | TradeSaleAction_Delivered | TradeSaleAction_Purchaser_invoiced | TradeSaleAction_Purchaser_paid | TradeSaleAction_Paid_organisation;

export interface TradeSaleActionOpts {
  cancelled: null;
  purchaser_accepted: (CollectionDetails|null);
  purchaser_rejected: null;
  production_order_complete: null;
  ready_for_collection: null;
  collected: common.LocalDate;
  delivered: common.LocalDate;
  purchaser_invoiced: common_db.DbKey<ferovinum_app_db.Invoice>;
  purchaser_paid: common.LocalDate;
  paid_organisation: OrgPaymentInfo;
}

export function makeTradeSaleAction<K extends keyof TradeSaleActionOpts>(kind: K, value: TradeSaleActionOpts[K]) { return {kind, value}; }

const TradeSaleAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.tradesale","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"cancelled","default":{"kind":"nothing"},"name":"cancelled","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"purchaser_accepted","default":{"kind":"nothing"},"name":"purchaser_accepted","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.tradesale","name":"CollectionDetails"}},"parameters":[]}]}},{"annotations":[],"serializedName":"purchaser_rejected","default":{"kind":"nothing"},"name":"purchaser_rejected","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"production_order_complete","default":{"kind":"nothing"},"name":"production_order_complete","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"ready_for_collection","default":{"kind":"nothing"},"name":"ready_for_collection","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"collected","default":{"kind":"nothing"},"name":"collected","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"delivered","default":{"kind":"nothing"},"name":"delivered","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaser_invoiced","default":{"kind":"nothing"},"name":"purchaser_invoiced","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Invoice"}},"parameters":[]}]}},{"annotations":[],"serializedName":"purchaser_paid","default":{"kind":"nothing"},"name":"purchaser_paid","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"paid_organisation","default":{"kind":"nothing"},"name":"paid_organisation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.tradesale","name":"OrgPaymentInfo"}},"parameters":[]}}]}},"name":"TradeSaleAction","version":{"kind":"nothing"}}};

export const snTradeSaleAction: ADL.ScopedName = {moduleName:"ferovinum.app.tradesale", name:"TradeSaleAction"};

export function texprTradeSaleAction(): ADL.ATypeExpr<TradeSaleAction> {
  return {value : {typeRef : {kind: "reference", value : snTradeSaleAction}, parameters : []}};
}

export interface CollectionDetails {
  collectionDate: common.LocalDate;
  collectionTime: common.LocalTime;
  collectionName: string;
  vehicleRegistration: (string|null);
  contactName: (string|null);
  contactNumber: (string|null);
}

export function makeCollectionDetails(
  input: {
    collectionDate: common.LocalDate,
    collectionTime: common.LocalTime,
    collectionName: string,
    vehicleRegistration: (string|null),
    contactName: (string|null),
    contactNumber: (string|null),
  }
): CollectionDetails {
  return {
    collectionDate: input.collectionDate,
    collectionTime: input.collectionTime,
    collectionName: input.collectionName,
    vehicleRegistration: input.vehicleRegistration,
    contactName: input.contactName,
    contactNumber: input.contactNumber,
  };
}

const CollectionDetails_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.tradesale","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"collectionDate","default":{"kind":"nothing"},"name":"collectionDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"collectionTime","default":{"kind":"nothing"},"name":"collectionTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[],"serializedName":"collectionName","default":{"kind":"nothing"},"name":"collectionName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"vehicleRegistration","default":{"kind":"nothing"},"name":"vehicleRegistration","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"contactName","default":{"kind":"nothing"},"name":"contactName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"contactNumber","default":{"kind":"nothing"},"name":"contactNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"CollectionDetails","version":{"kind":"nothing"}}};

export const snCollectionDetails: ADL.ScopedName = {moduleName:"ferovinum.app.tradesale", name:"CollectionDetails"};

export function texprCollectionDetails(): ADL.ATypeExpr<CollectionDetails> {
  return {value : {typeRef : {kind: "reference", value : snCollectionDetails}, parameters : []}};
}

export interface OrgPaymentInfo {
  paymentDate: common.LocalDate;
  fxRate: (common.BigDecimal|null);
}

export function makeOrgPaymentInfo(
  input: {
    paymentDate: common.LocalDate,
    fxRate: (common.BigDecimal|null),
  }
): OrgPaymentInfo {
  return {
    paymentDate: input.paymentDate,
    fxRate: input.fxRate,
  };
}

const OrgPaymentInfo_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.tradesale","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"paymentDate","default":{"kind":"nothing"},"name":"paymentDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"fxRate","default":{"kind":"nothing"},"name":"fxRate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}}]}},"name":"OrgPaymentInfo","version":{"kind":"nothing"}}};

export const snOrgPaymentInfo: ADL.ScopedName = {moduleName:"ferovinum.app.tradesale", name:"OrgPaymentInfo"};

export function texprOrgPaymentInfo(): ADL.ATypeExpr<OrgPaymentInfo> {
  return {value : {typeRef : {kind: "reference", value : snOrgPaymentInfo}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.tradesale.TradeSaleAction" : TradeSaleAction_AST,
  "ferovinum.app.tradesale.CollectionDetails" : CollectionDetails_AST,
  "ferovinum.app.tradesale.OrgPaymentInfo" : OrgPaymentInfo_AST
};
